import { render } from "./vanessa.vue?vue&type=template&id=66d9d9c7"
import script from "./vanessa.vue?vue&type=script&lang=js"
export * from "./vanessa.vue?vue&type=script&lang=js"

import "./vanessa.vue?vue&type=style&index=0&id=66d9d9c7&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__